import * as React from 'react';
import { IconButton, DropdownMenu } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const exportOptions = ['csv', 'xlsx'] as const;

export type ExportType = (typeof exportOptions)[number];

export type ExportResultsProps = {
  [key in ExportType]?: boolean;
} & {
  onExportSelected: (exportType: ExportType) => void;
  disabledTooltip?: string;
  isDisabled?: boolean;
};

export const exportOptionsLabels: Record<ExportType, string> = {
  csv: 'export-to-csv',
  xlsx: 'export-to-xlsx',
};

export const ExportResults = (props: ExportResultsProps): JSX.Element => {
  const { onExportSelected, isDisabled, disabledTooltip } = props;
  const { t } = useTranslation('feedback', { keyPrefix: 'common.responses-list' });

  return (
    <>
      {isDisabled === true ? (
        <IconButton
          size="s"
          kind="ghost"
          icon="download"
          isDisabled
          tooltipText={isDisabled ? disabledTooltip ?? t('download') : t('download')}
          description={t('download-results')}
        />
      ) : (
        <DropdownMenu
          trigger={
            <IconButton
              size="s"
              kind="ghost"
              icon="download"
              tooltipText={t('download')}
              description={t('download-results')}
            />
          }
        >
          {exportOptions
            // eslint-disable-next-line react/destructuring-assignment
            .filter((exportType) => props[exportType])
            .map((exportType) => {
              return (
                <DropdownMenu.Item key={exportType} onClick={() => onExportSelected(exportType)}>
                  {t(exportOptionsLabels[exportType])}
                </DropdownMenu.Item>
              );
            })}
        </DropdownMenu>
      )}
    </>
  );
};
